import React from 'react'

/**
 * Auth-loading placeholder. Intentionally renders an empty dark background
 * (no skeleton, no spinner) so when authLoading flips false and the real
 * screen mounts, the user sees a single transition into that screen's own
 * skeleton — no full-page → screen-skeleton double-loader.
 */
function LoadingScreen() {
  return <div className="min-h-screen w-full bg-dark-bg" />
}

export default LoadingScreen
